import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/fabric-sales.css";

// Debug React version and internals
console.log('React version:', React.version);
console.log('React internals:', React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED ? 'Available' : 'Missing');

try {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root container not found");
  }
  
  const root = createRoot(container);
  root.render(<App />);
} catch (error) {
  console.error("Failed to initialize app:", error);
  
  // Fallback rendering
  document.body.innerHTML = `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 100vh; font-family: system-ui;">
      <div style="text-align: center;">
        <h1>Loading Fabric Sales...</h1>
        <p>Error: ${error.message}</p>
        <p>Please refresh if the application doesn't load.</p>
      </div>
    </div>
  `;
}
